import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[sticky]'
})
export class StickyDirective implements AfterViewInit, OnDestroy {
  @Input() top;
  @Input() bottom;
  @Input() scrollContainer: string;
  @Output() sticky = new EventEmitter();
  private scrollUnlistener: () => void;

  constructor(private el: ElementRef,
    private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    if (this.scrollContainer) {
      const container = document.querySelector(this.scrollContainer);
      if (container) {
        this.scrollUnlistener = this.renderer.listen(container, 'scroll', () => {
          this.checkSticky();
        });
        // Initial check
        this.checkSticky();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.scrollUnlistener) {
      this.scrollUnlistener();
    }
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:scroll', ['$event'])
  @HostListener('document:mousewheel', ['$event'])
  onDocumentMousewheelEvent(event) {
    this.checkSticky();
  }

  checkSticky() {
    if (!this.top) {
      if (this.scrollContainer) {
        const container = document.querySelector(this.scrollContainer);
        if (container) {
          this.top = container.getBoundingClientRect().top / 16;
        }
      } else {
        this.top = document.querySelector('.h-header')?.clientHeight / 16;
      }
    }

    if (this.top) {
      //  
      if (this.el.nativeElement.parentNode?.getBoundingClientRect()?.top <= (this.top * 16)) {
        this.renderer.setStyle(this.el.nativeElement.children[0], 'top', this.top * 16 + 'px');
        this.renderer.setStyle(this.el.nativeElement.children[0], 'width', this.el.nativeElement?.parentNode?.getBoundingClientRect()?.width + 'px')
        this.renderer.setStyle(this.el.nativeElement.children[0], 'position', 'fixed');
        this.sticky.emit(true);
      }
      else if (this.el.nativeElement?.parentNode?.getBoundingClientRect()?.top > this.top * 16) {
        this.renderer.setStyle(this.el.nativeElement.children[0], 'position', 'static');
        this.sticky.emit(false);
      }
      if (this.el?.nativeElement?.children?.length)
        this.renderer.setStyle(this.el?.nativeElement?.children[0], 'width', this.el?.nativeElement?.parentNode?.getBoundingClientRect()?.width + 'px')
    }

    else
      this.sticky.emit(false);
    // let footerValues = document.querySelector<HTMLElement>('footer').getBoundingClientRect();
    // if (this.bottom && window.innerHeight - (footerValues.bottom - footerValues.height) >= 0)
    //   this.bottom =
    //     window.innerHeight -
    //     (footerValues.bottom - footerValues.height) +
    //     footerValues.height / 4;
    // else this.bottom = footerValues.height / 4;
  }

}
